/**
 * @async
 * @function makeGroupByAppName
 * @param { array } tabs
 * @returns { Promise<Array> }
 */
async function makeGroupByAppName(tabs) {
	const cantabs = await tabs.reduce((accu, tab) => {
		const { appName } = tab;

		if (accu[appName] === null || accu[appName] === undefined) {
			accu[appName] = [];
		}

		accu[appName].push(tab);

		return accu;
	}, {});

	const _cantabs = Object.entries(cantabs).map((value, index) => {
		return { id: index, name: value[0], tabs: value[1] };
	});

	return _cantabs;
}

export default makeGroupByAppName;
